import { InvoiceStatusEnum } from 'src/graphql/schema';

export const labelStatusMap = {
  [InvoiceStatusEnum.Paid]: {
    text: 'Paid',
    bgColor: 'bg-secondary-foreground',
    color: 'text-white',
  },
  [InvoiceStatusEnum.NotPaid]: {
    text: 'Not paid',
    bgColor: 'bg-destructive',
    color: 'text-white',
  },
  [InvoiceStatusEnum.PaymentDue]: {
    text: 'Due',
    bgColor: 'bg-secondary',
    color: 'text-white',
  },
  [InvoiceStatusEnum.Posted]: {
    text: 'Posted',
    bgColor: 'bg-white border-border',
    color: 'text-foreground',
  },
  [InvoiceStatusEnum.Voided]: {
    text: 'Voided',
    bgColor: 'bg-ck-gray-100',
    color: 'text-foreground',
  },
  [InvoiceStatusEnum.Pending]: {
    text: 'Pending',
    bgColor: 'bg-white border-border',
    color: 'text-foreground',
  },
} as const;
